// @flow

import Task, {
  CreateTaskRequest,
  UpdateTaskRequest
} from "../../models/Task/Task";
import TaskApi from "../../api/TaskApi/TaskApi";

// Intentional pass-through: TaskApi's calls need no validation/transformation
// today. Kept as a service (rather than consumed directly by TaskBloc) so the
// bloc->service->api chain stays consistent across entities; add real logic
// here if/when it's needed instead of bypassing this layer.
class TaskService {
  taskApi: TaskApi;

  constructor(taskApi: TaskApi) {
    this.taskApi = taskApi;
  }

  async getAllTasks(taskListId): Promise<Array<Task>> {
    return await this.taskApi.getAll(taskListId);
  }

  async createTask(createTaskRequest: CreateTaskRequest): Promise<Task> {
    return await this.taskApi.createTask(createTaskRequest);
  }

  async updateTask(updateTaskRequest: UpdateTaskRequest): Promise<Task> {
    return await this.taskApi.updateTask(updateTaskRequest);
  }

  async removeTaskFromTaskList(taskId: string): Promise<Task> {
    return await this.taskApi.removeTaskFromList(taskId);
  }

}

export default TaskService;
